const doc = [({"en":({"js":({"admin":({"layout":({"slide_menu":({"time_and_reimbursement":"Time and Reimbursement"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;